<script setup lang="ts">
import { getTipoCadastroList } from '@/config/cadastros'
import type { TipoCadastro } from '@/types'

interface Props {
  modelValue: TipoCadastro | null
  disabled?: boolean
}

interface Emits {
  (e: 'update:modelValue', value: TipoCadastro): void
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false
})

const emit = defineEmits<Emits>()

const cadastros = getTipoCadastroList()

const selectCadastro = (tipo: TipoCadastro) => {
  if (!props.disabled) {
    emit('update:modelValue', tipo)
  }
}
</script>

<template>
  <div class="cadastro-selector">
    <div
      v-for="cadastro in cadastros"
      :key="cadastro.value"
      class="cadastro-card"
      :class="{
        'cadastro-card--selected': modelValue === cadastro.value,
        'cadastro-card--disabled': disabled
      }"
      @click="selectCadastro(cadastro.value)"
    >
      <div class="cadastro-card__icon">
        <v-icon
          :color="modelValue === cadastro.value ? 'primary' : '#94A3B8'"
          size="32"
        >
          {{ cadastro.config.icon }}
        </v-icon>
      </div>
      <div class="cadastro-card__label">
        {{ cadastro.config.label }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.cadastro-selector {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.cadastro-card {
  flex: 1 1 132px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 16px;
  background: #FFFFFF;
  border: 2px solid #E2E8F0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 100px;

  &:hover:not(.cadastro-card--disabled) {
    border-color: #CBD5E1;
    background: #F8FAFC;
  }

  &--selected {
    border-color: #2563EB !important;
    background: #EFF6FF !important;
  }

  &--disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &__icon {
    margin-bottom: 8px;
  }

  &__label {
    font-size: 14px;
    font-weight: 500;
    color: #334155;
  }
}

@media (max-width: 600px) {
  .cadastro-card {
    flex-basis: 120px;
    padding: 16px 12px;
    min-width: 80px;

    &__label {
      font-size: 12px;
    }
  }
}
</style>
